import { defineComponent as _defineComponent } from 'vue'
import { AnimatedButton } from '@shared/ui'


export default /*#__PURE__*/_defineComponent({
  __name: 'RestaurantNotWorking',
  emits: ['onClick'],
  setup(__props, { emit: emits }) {



const onClick = () => {
  emits('onClick')
}

return { __sfc: true,emits, onClick, AnimatedButton }
}

})